import { Injectable } from "@angular/core";
import { HttpService } from "../infrastructure/http/http";
import { Auth } from "../infrastructure/auth";
import { UserService } from "../domain/user-service";

@Injectable()
export class SuperuserService {
  constructor(
    private http: HttpService,
    private auth: Auth,
    private userService: UserService,
  ) {}

  async handleChannelParameter() {
    const urlParams = new URLSearchParams(window.location.search);
    const channelGuid = urlParams.get("channelGuid");
    if (channelGuid) {
      await this.loginWithChannelTenant(channelGuid);
    }
  }

  private async loginWithChannelTenant(channelGuid: string): Promise<void> {
    try {
      const currentUser = this.userService.getCurrentUser();
      if (!currentUser.isSuperUser) {
        throw new Error();
      }

      const response = await this.http.get(
        `/channel/loginToChannel?channelGuid=${channelGuid}`,
      );
      const { newToken, channel } = response;

      newToken.expiry *= 1000;
      newToken.expiry += new Date().valueOf();
      this.auth.token = newToken;
      // @ts-ignore
      this.userService.setCurrentChannel({
        id: channel.Id,
        timezoneId: channel.TimeZone,
      });
    } finally {
      window.location.replace(location.pathname);
    }
  }
}
